import { Spinner } from '@monksflow/monks-ui';
import { UserRoundIcon } from 'lucide-react';

/**
 * Stands in for the portrait while it is being generated, or after that failed.
 *
 * The card is mostly image, so leaving the area blank reads as a broken card rather than as
 * one still being filled in. A spinner says work is happening and roughly that it is slow; a
 * still frame says it stopped.
 */
export const SuggestedAudiencePortrait = ({ building }: { building: boolean }) => (
  <div
    className="flex h-full w-full items-center justify-center bg-muted"
    data-testid="suggested-audience-portrait"
    data-state={building ? 'building' : 'missing'}
  >
    {building ? (
      <Spinner />
    ) : (
      <UserRoundIcon className="text-muted-foreground" size={32} aria-hidden />
    )}
  </div>
);
